class PetPawMegaMenu {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[data-petpaw-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-petpaw-panel]'));
    this.trigger = root.querySelector('.petpaw-nav__trigger');

    this.tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', () => this.activate(tab.dataset.petpawTab));
      tab.addEventListener('focus', () => this.activate(tab.dataset.petpawTab));
      tab.addEventListener('click', () => this.activate(tab.dataset.petpawTab));
    });

    if (this.trigger) {
      this.trigger.addEventListener('click', () => {
        const isOpen = this.root.classList.toggle('is-open');
        this.trigger.setAttribute('aria-expanded', String(isOpen));
        const panel = this.root.querySelector('.petpaw-mega');
        if (panel) panel.setAttribute('aria-hidden', String(!isOpen));
      });
    }

    this.root.addEventListener('mouseenter', () => this.setExpanded(true));
    this.root.addEventListener('mouseleave', () => this.setExpanded(false));
    this.root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.root.classList.remove('is-open');
        this.setExpanded(false);
        this.trigger?.focus();
      }
    });
  }

  activate(index) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.petpawTab === String(index);
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.petpawPanel === String(index);
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  setExpanded(expanded) {
    if (!this.trigger) return;
    this.trigger.setAttribute('aria-expanded', String(expanded));
    const panel = this.root.querySelector('.petpaw-mega');
    if (panel) panel.setAttribute('aria-hidden', String(!expanded));
    if (!expanded) this.root.classList.remove('is-open');
  }
}

const initPetPawHeader = (scope = document) => {
  scope.querySelectorAll('[data-petpaw-mega]').forEach((root) => {
    if (root.dataset.petpawReady === 'true') return;
    root.dataset.petpawReady = 'true';
    new PetPawMegaMenu(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initPetPawHeader());
document.addEventListener('shopify:section:load', (event) => initPetPawHeader(event.target));



const initPetPawStickyState = () => {
  const header = document.querySelector('.petpaw-header');
  if (!header) return;

  const shouldStick = header.classList.contains('petpaw-header--sticky');
  const sectionWrapper = header.closest('.shopify-section') || header.parentElement;

  if (sectionWrapper) {
    sectionWrapper.classList.toggle('petpaw-header-section--sticky', shouldStick);
  }

  if (header._petpawScrollHandler) {
    window.removeEventListener('scroll', header._petpawScrollHandler);
    header._petpawScrollHandler = null;
  }

  if (!shouldStick) {
    header.classList.remove('is-scrolled');
    return;
  }

  const onScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 18);
  };

  header._petpawScrollHandler = onScroll;
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
};

document.addEventListener('DOMContentLoaded', initPetPawStickyState);
document.addEventListener('shopify:section:load', initPetPawStickyState);
document.addEventListener('shopify:section:reorder', initPetPawStickyState);
